<if(input.listingId && input.renderBody)>
    <div on-click("onClickOpen") on-keyup("onKeyupOpen")
        role="button"
        tabindex="0"
        class=`str-quickview-button ${input.classAttr}`
        aria-label=`${input.itemTitle} : ${input.label}`
        data-track=input.tracking>

        <${input.renderBody}/>
    </div>
</if>
